export const registerEn = {
  "pos.recovery.others.title": "Other operators' payments",
  "pos.recovery.others.help": "A check with an open payment cannot be charged. Check the drawer, then acknowledge a recorded payment or withdraw one that was never taken. Only the operator can complete it, so nothing is charged from here.",
  "pos.recovery.others.empty": "No other operator has an open payment.",
  "pos.recovery.others.operator": "Prepared by",
  "pos.recovery.others.resolve": "Acknowledge recorded outcome",
  "pos.correction.title": "Correct this charge",
  "pos.correction.subtitle": "Nothing on the sale or a closed day changes. A correcting entry posts today in the open period.",
  "pos.correction.charged": "Charged to",
  "pos.correction.left": "Left on this charge",
  "pos.correction.tipLeft": "Gratuity left",
  "pos.correction.kind": "What needs correcting",
  "pos.correction.kind.void": "Void the whole charge",
  "pos.correction.kind.partial": "Take back part of it",
  "pos.correction.kind.move": "Move it to the right member",
  "pos.correction.quantityHelp": "Enter the quantity to take back. Tax and service charge follow each line exactly.",
  "pos.correction.quantity": "Quantity to take back",
  "pos.correction.available": "Left",
  "pos.correction.tip": "Gratuity to take back",
  "pos.correction.moveTo": "Member who should be charged",
  "pos.correction.moveToChosen": "Moves to {name}",
  "pos.correction.change": "Choose another member",
  "pos.correction.restock": "The goods came back to stock",
  "pos.correction.restockHint": "Leave this off for anything served or used.",
  "pos.correction.reason": "Reason",
  "pos.correction.reviewAgain": "Review again",
  "pos.correction.review": "Review correction",
  "pos.correction.invalid": "Choose what to correct and give a reason of at least 3 characters.",
  "pos.correction.reviewTitle": "Review before posting",
  "pos.correction.items": "Items",
  "pos.correction.service": "Service charge",
  "pos.correction.tax": "Tax",
  "pos.correction.gratuity": "Gratuity",
  "pos.correction.total": "Total credited",
  "pos.correction.totalMoved": "Total moved",
  "pos.correction.from": "From",
  "pos.correction.to": "To",
  "pos.correction.posts": "Posts on {date}",
  "pos.correction.minimum": "Minimum spend changes in the month this posts ({date}), not the month of the sale. A shortfall already billed is not recalculated.",
  "pos.correction.paid": "{amount} was already paid. It comes off the payment and stays as credit on the account.",
  "pos.correction.statement": "This charge is on a finalised statement. That statement stands; the correction shows on the next one.",
  "pos.correction.returns": "Back to stock: {items}",
  "pos.correction.noStock": "Stock is unchanged.",
  "pos.correction.ack": "I reviewed the amounts and the member",
  "pos.correction.confirm": "Post correction",
  "pos.correction.done": "Correction posted.",
  "pos.correction.history": "Corrections on this check",
  "pos.correction.none": "No corrections yet.",
  "pos.correction.finished": "Nothing is left to correct on this charge.",
  "pos.correction.blocked.pos_correction_unsupported": "Only a check charged to a member account can be corrected here.",
  "pos.correction.blocked.pos_correction_not_settled": "This check is not settled, so it can still be changed on the check.",
  "pos.correction.blocked.funding_correction_required": "This check was paid with funds on the bill. Use its original-tender refund.",
  "pos.correction.blocked.payment_recovery_pending": "A payment on this check is open. Resolve it in Payment recovery first.",
  "pos.correction.dayTotal": "Corrections of member charges",
  "pos.correction.dayMoved": "Moved to another member (no change to sales)",
  "pos.register.resetLookup": "Reset check filters",
  "pos.register.findChecks": "Find checks",
  "pos.register.businessDate": "Business date",
  "pos.register.allDates": "All business dates",
  "pos.register.searchChecks": "Find check, table, member or member number",
  "pos.register.refreshChecks": "Refresh checks",
  "pos.register.clearSearch": "Clear search",

  "pos.register.checkSettlement": "Check settlement status",
  "pos.register.statusUnresolved": "Settlement is not confirmed. Keep this request unchanged and retry it or ask a manager to review. An open check does not prove the earlier request failed.",

  "pos.register.details": "Table & server",
  "pos.register.detailsHelp": "Change the table, covers or assigned server. Kitchen screens show the current assignment; existing food tickets are preserved and routed printers receive an order-update notice.",
  "pos.register.invalidDetails": "Use a table label of up to 12 letters, numbers, spaces or hyphens, and a whole cover count from 0 to 500.",
  "pos.register.reloadCheck": "Reload current check",
  "pos.register.searchStaff": "Search staff",
  "pos.register.unassigned": "Unassigned",
  "pos.register.currentServer": "Current server",
  "pos.register.settlePendingCourses": "Closing this check sends all remaining pending items, including later courses and manually held items. Review the order before charging.",
  "pos.register.nextCourse": "Send next: course {course}",
  "pos.register.nextCourseEmpty": "Send next course",
  "pos.register.chooseCourse": "Fire a course…",
  "pos.register.courseHelp": "Choose a course to send. Manually held lines and other courses stay pending.",
  "pos.register.sendAllCourses": "Send all unheld courses",
  "pos.register.course": "Course",
  "pos.register.courseNumber": "Course {course}",
  "pos.register.fireCourse": "Fire course {course}",
  "pos.register.decrease": "Decrease {label}",
  "pos.register.increase": "Increase {label}",
  "pos.register.limit": "Credit limit: {amount}",
  "pos.register.wouldBe": "Balance after charge: {amount}",
  "pos.register.overrideRequired": "Enter the reason for this override.",
  "pos.register.barcode": "Scan barcode or enter SKU",
  "pos.register.lookup": "Add scanned item",
  "pos.register.unavailable":
    "This item or variant is not sold at this outlet today.",
  "pos.register.title": "POS register",
  "pos.register.subtitle":
    "Open a check, take an order and settle from one touchscreen.",
  "pos.register.outlet": "Outlet",
  "pos.register.chooseOutlet": "Choose an outlet",
  "pos.register.open": "Open",
  "pos.register.settled": "Settled",
  "pos.register.voided": "Voided",
  "pos.register.mine": "My checks only",
  "pos.register.new": "New check",
  "pos.register.table": "Table / reference",
  "pos.register.searchOrScan": "Search or scan",
  "pos.register.quickCharge": "Charge {amount} to {name}",
  "pos.register.lineActions": "Actions for {line}",
  "pos.register.ringForMember": "Ring for a member",
  "pos.register.covers": "Covers",
  "pos.register.coverCount_one": "{count} cover",
  "pos.register.coverCount_other": "{count} covers",
  "pos.register.tenderChosen": "Paying by: {tender}",
  "pos.register.empty": "No open checks",
  "pos.register.noMatches": "No checks match these filters",
  "pos.register.check": "Check {number}",
  "pos.register.lines": "{count} items",
  "pos.register.menu": "Menu",
  "pos.register.all": "All categories",
  "pos.register.search": "Search menu",
  "pos.register.send": "Send order",
  "pos.register.sentCount": "Sent {count} items",
  "pos.register.held": "Held",
  "pos.register.sent": "Sent",
  "pos.register.comped": "Comped",
  "pos.register.pending": "Pending",
  "pos.register.seat": "Seat",
  "pos.register.quantity": "Quantity",
  "pos.register.note": "Kitchen note",
  "pos.register.hold": "Hold from kitchen",
  "pos.register.add": "Add to check",
  "pos.register.choices": "Choose options",
  "pos.register.variant": "Variant",
  "pos.register.selection": "Choose at least {min}; maximum {max}",
  "pos.register.any": "any",
  "pos.register.invalidChoices":
    "Complete the required choices and check quantities.",
  "pos.register.move": "Move to seat",
  "pos.register.edit": "Edit item",
  "pos.register.voidLine": "Void item",
  "pos.register.compLine": "Comp item",
  "pos.register.voidCheck": "Void check",
  "pos.register.reason": "Reason",
  "pos.register.chooseReason": "Choose a reason",
  "pos.register.noReasons":
    "No active reasons. A manager must configure reasons first.",
  "pos.register.approval": "Manager approval required",
  "pos.register.managerEmail": "Manager email",
  "pos.register.managerPassword": "Manager password",
  "pos.register.approve": "Approve and continue",
  "pos.register.attach": "Attach member",
  "pos.register.memberSearch": "Find member by number or name",
  "pos.register.typeMember": "Type a number or a name",
  "pos.register.noMembers": "Nobody matches",
  "pos.register.account": "Account {number} · {status}",
  "pos.register.balance": "Balance: {amount}",
  "pos.register.available": "Available credit: {amount}",
  "pos.register.noLimit": "No limit",
  "pos.register.selectMember": "Choose {name}",
  "pos.register.photo": "Member photo",
  "pos.register.settle": "Settle check",
  "pos.register.member_charge": "Member charge",
  "pos.register.room_charge": "Room charge",
  "pos.register.no_charge": "No charge",
  "pos.register.room": "Room / cottage",
  "pos.register.gratuity": "Gratuity amount",
  "pos.register.paper": "Signed paper chit",
  "pos.register.preview": "Review charge",
  "pos.register.charge": "Charge {amount}",
  "pos.register.previewTotal": "Final total: {amount}",
  "pos.register.after": "Balance after: {amount}",
  "pos.register.override": "Override credit/account restriction",
  "pos.register.overrideReason": "Override reason",
  "pos.register.changed":
    "The total changed. Review the updated amount before charging again.",
  "pos.register.moneyInvalid":
    "Enter a non-negative amount with up to two decimal places.",
  "pos.register.receipt": "Receipt",
  "pos.register.print": "Print receipt",
  "pos.register.back": "Back to register",
  "pos.register.subtotal": "Subtotal",
  "pos.register.service": "Service charge",
  "pos.register.discount": "Discount",
  "pos.register.total": "Total",
  "pos.register.signature": "Signature",
  "pos.register.noMenu": "No menu items are available at this outlet.",
  "pos.register.emptyCheck": "Choose an item to start this order.",
  "pos.register.date": "Business date",
  "pos.register.dayClose": "Day close",
  "pos.register.closeDay": "Close the day",
  "pos.register.openBlocksClose":
    "Finish or void the open checks before closing.",
  "pos.register.closed": "Day closed",
  "pos.register.checksSettled": "Settled checks: {count}",
  "pos.register.checksVoided": "Voided checks: {count}",
  "pos.register.reasons": "Void and comp reasons",
  "pos.register.code": "Code",
  "pos.register.name": "Name",
  "pos.register.kind": "Kind",
  "pos.register.void": "Void",
  "pos.register.comp": "Comp",
  "pos.register.both": "Void and comp",
  "pos.register.needsApproval": "Requires manager approval",
  "pos.register.active": "Active",
  "pos.register.newReason": "New reason",
  "pos.register.saved": "Saved",
  "pos.register.settleNeedsMember": "Choose a member who can sign.",
  "pos.register.settleNeedsRoom": "Choose a room or cottage.",
  "pos.register.allChecks": "Checks",
  "pos.register.retry": "Retry",
  "pos.register.cancelRetry": "Discard pending retry",
  "pos.register.retryNotice":
    "A request has an uncertain outcome. Retry it with the same identifier before adding another item.",
  "pos.register.server": "Server",
  "pos.nav.register": "Register",
  "pos.nav.dayClose": "Day close",
  "pos.nav.reasons": "Reasons",
  "pos.register.searchHint": "Search names, variants, SKUs or barcodes.",
  "pos.register.priceFrom": "From {price}",
  "pos.register.noMenuMatches": "No items match this search and category.",
  "pos.register.clearMenuFilters": "Clear menu filters",
  "pos.move.title": "Split / move items",
  "pos.move.help": "Move selected quantities, whole items or a seat to a new or existing check. Copied prices, comps and original kitchen history are retained. Sent food is not prepared again.",
  "pos.move.portion": "Split portion",
  "pos.move.quantity": "Quantity to move · {item}",
  "pos.move.quantityInvalid": "Enter a positive quantity with up to three decimals, no greater than the quantity on each selected line.",
  "pos.move.remaining": "{quantity} remains on source",
  "pos.move.invalid": "Select 1–500 items and enter valid table and cover details.",
  "pos.move.destinationUnavailable": "Choose an open destination and wait for its details.",
  "pos.move.retry": "Retry the same move",
  "pos.move.confirm": "Confirm move",
  "pos.move.preview": "Preview move",
  "pos.move.uncertain": "The result is uncertain. Retry this same move before making another request. It cannot be applied twice.",
  "pos.move.reviewDestination": "Destination",
  "pos.move.newCheck": "New split check",
  "pos.move.sourceAfter": "Source total after move",
  "pos.move.targetAfter": "Destination total after move",
  "pos.move.totalChange": "Combined total change",
  "pos.move.roundingHelp": "Separating quantities or combining checks can change price, discount and tax rounding. These are standard totals; payer exemptions and gratuities are reviewed at settlement.",
  "pos.move.mergesSource": "All live items are moving. The source will close as merged and link to the destination. This does not void food or post a payment.",
  "pos.move.edit": "Edit selection",
  "pos.move.selectBySeat": "Select items by seat",
  "pos.move.all": "All live items",
  "pos.move.destination": "Destination check",
  "pos.move.newCovers": "Covers on the new check",
  "pos.move.openDestination": "This check was merged — open destination",
  "pos.move.sourceBefore": "Source total before move",
  "pos.move.targetBefore": "Destination total before move",
  "pos.register.merged": "Merged",
};
export type RegisterMessages = typeof registerEn;
